export default __webpack_public_path__ + "static/media/digital_alarm.62b91802.mp3";